export const NOTIFICATION_READ_REQUEST = 'notification read request'
export const NOTIFICATION_READ_SUCCESS = 'notification read success'
export const NOTIFICATION_READ_FAILURE= 'notification read failure'
export const SET_NOTIFICATION_READ = 'Set notification read'
export const ADD_NOTIFICATION = 'Add notification'
// ==============read================
export const readRequest = () => ({
    type: NOTIFICATION_READ_REQUEST,
    isFetching: true
})

export const readSuccess = (notification) => ({
    type: NOTIFICATION_READ_SUCCESS,
    notification: notification,
    isFetching: false
})

export const readFailure = (error, response) => ({
    type: NOTIFICATION_READ_FAILURE,
    isFetching: false,
    error: error,
    response: response
})

export function setRead(notificationId){
      return{
          type: SET_NOTIFICATION_READ,
          notificationId: notificationId
    }
}

export function addNotification(notification){
    return{
        type: ADD_NOTIFICATION,
        notification: notification
    }
}


// WEBPACK FOOTER //
// ./src/model/Notification/actions.js